/** @file Writes offset triangle indices into the index buffer with topology change tracking. */
import type { RenderBuffers } from '../renderBuffers';
import type { BuildState } from './buildState';

/** Writes `base + tris[k]` at index `st.i + k`; flags `changed` and `topo` only when an index differs; advances `st.i`. */
export function writeTriangles(out: RenderBuffers, st: BuildState, tris: ArrayLike<number>, base: number): void {
  const indices = out.indices, start = st.i;
  let changed = false;
  for (let k = 0; k < tris.length; k++) {
    const value = base + (tris[k] ?? 0);
    if (indices[start + k] !== value) {
      indices[start + k] = value;
      changed = true;
    }
  }
  if (changed) {
    st.changed = true;
    st.topo = true;
  }
  st.i = start + tris.length;
}
